import React, { useState } from "react";
import { Excalidraw } from "@excalidraw/excalidraw";

const StudentWhiteboardTab = ({ form, whiteboards = [] }) => {
  const [selectedBoard, setSelectedBoard] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  return (
    <div className="h-screen flex flex-col">
      {!selectedBoard ? (
        <div className="p-4">
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-2">
              Your Assigned Whiteboards
            </h2>
            <p className="text-gray-600">
              Form: <strong className="text-blue-600">{form}</strong> | 
              Total: {whiteboards.length} whiteboard{whiteboards.length !== 1 ? "s" : ""}
            </p>
          </div>

          {whiteboards.length === 0 ? (
            <div className="text-center py-12">
              <div className="text-6xl mb-4">📝</div>
              <h3 className="text-xl font-semibold text-gray-700 mb-2">
                No Whiteboards Assigned
              </h3>
              <p className="text-gray-500">
                Your teacher hasn't assigned any whiteboards to your form yet.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {whiteboards.map((board) => (
                <div
                  key={board.id}
                  className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow bg-white"
                >
                  <div className="mb-3">
                    <h3 className="font-bold text-lg text-gray-800 mb-1">
                      {board.title}
                    </h3>
                    <div className="text-sm text-gray-500 space-y-1">
                      <p>📚 Form: {board.form}</p>
                      <p>👨‍🏫 Teacher: {board.teacher_email || "N/A"}</p>
                      <p>
                        📅 Created:{" "}
                        {new Date(board.created_at).toLocaleDateString()}
                      </p>
                    </div>
                  </div>

                  <button
                    onClick={() => setSelectedBoard(board)}
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-md transition-colors font-medium"
                  >
                    📖 Open Whiteboard
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        // ✅ Whiteboard Viewer
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-between p-4 bg-gray-50 border-b">
            <div className="flex items-center space-x-4">
              <button
                onClick={() => setSelectedBoard(null)}
                className="flex items-center text-blue-600 hover:text-blue-800 font-medium"
              >
                ← Back to List
              </button>
              <div className="border-l border-gray-300 pl-4">
                <h1 className="text-xl font-bold text-gray-800">
                  {selectedBoard.title}
                </h1>
                <p className="text-sm text-gray-600">
                  Form: {selectedBoard.form}
                </p>
              </div>
            </div>

            {/* View Mode Indicator */}
            <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
              👁️ View Only
            </div>
          </div>

          {/* Excalidraw Canvas */}
          <div className="flex-1">
            <Excalidraw
              initialData={{
                elements: selectedBoard.elements || [],
                files: selectedBoard.files || {},  // ✅ Include files for images
                appState: {
                  viewModeEnabled: true,
                  zenModeEnabled: false,
                  gridModeEnabled: true,
                },
              }}
              viewModeEnabled={true}
              UIOptions={{
                canvasActions: {
                  export: {
                    saveFileToDisk: false, // ✅ Disable file saving for students
                    saveAsImage: true,     // ✅ Allow image export
                    exportToBackend: false, // ✅ No backend export
                  },
                  clearCanvas: false,      // ✅ Prevent students from clearing
                  loadScene: false,        // ✅ Prevent students from loading scenes
                },
                tools: {
                  image: false,            // ✅ Disable image insertion
                },
                mainMenu: {
                  customItems: [
                    {
                      label: "📄 Print Whiteboard",
                      action: () => window.print(),
                    },
                    {
                      label: "💾 Save as Image",
                      action: () => {
                        console.log("Saving whiteboard as image");
                        // You can implement custom image save logic here if needed
                      },
                    },
                  ],
                },
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentWhiteboardTab;
